const toNumber = (value) => {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value;
  }
  if (typeof value === 'string' && value.trim() !== '') {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }
  if (value && typeof value === 'object') {
    if (typeof value.id !== 'undefined') {
      return toNumber(value.id);
    }
    if (typeof value.pk !== 'undefined') {
      return toNumber(value.pk);
    }
  }
  return null;
};

const collectTokens = (raw) => {
  if (!raw) {
    return [];
  }
  const base = String(raw).trim().toLowerCase();
  if (!base) {
    return [];
  }
  const parts = base.split(/[\s,;:/\\|_-]+/).filter(Boolean);
  return [base, ...parts];
};

const buildSearchTokens = (user) => {
  const tokens = new Set();
  if (!user) {
    return tokens;
  }
  [
    user.username,
    user.full_name,
    user.client_name,
    user.email ? user.email.split('@')[0] : null,
    user.first_name,
    user.last_name,
  ].forEach((value) => {
    collectTokens(value).forEach((token) => tokens.add(token));
  });
  return tokens;
};

const gatherCandidateIds = (event) => {
  const candidates = [
    event?.user,
    event?.detected_by,
    event?.assigned_to,
    event?.assigned_to_id,
    event?.client_id,
    event?.client?.id,
    event?.client?.user_id,
    event?.camera?.client,
    event?.camera?.client_id,
    event?.camera?.client?.id,
    event?.camera?.client?.user_id,
    event?.metadata?.client_id,
    event?.metadata?.user_id,
  ];
  return candidates
    .map((value) => toNumber(value))
    .filter((value) => value !== null);
};

const gatherTextFields = (event) => {
  const fields = [
    event?.detected_by_display,
    event?.assigned_to_display,
    event?.camera?.name,
    event?.camera_name,
    event?.client_name,
    event?.client?.first_name,
    event?.client?.last_name,
    event?.client?.user?.username,
    event?.camera?.client_name,
    event?.camera?.client?.first_name,
    event?.camera?.client?.last_name,
    event?.notes,
    event?.label,
    event?.status,
  ];

  if (event?.metadata) {
    Object.values(event.metadata).forEach((value) => {
      if (typeof value === 'string') {
        fields.push(value);
      }
    });
  }

  if (Array.isArray(event?.tags)) {
    fields.push(...event.tags);
  }

  return fields.filter(Boolean);
};

export const scopeEventsForClient = (events, user) => {
  const original = Array.isArray(events) ? events : [];
  if (!original.length || !user) {
    return {
      events: [],
      tokens: [],
      fallback: false,
    };
  }

  const tokens = buildSearchTokens(user);
  const userIds = new Set(
    [user.user_id, user.client_id, user.id].map((value) => toNumber(value)).filter((value) => value !== null),
  );

  const seen = new Set();
  const matched = [];

  original.forEach((event) => {
    if (!event || typeof event !== 'object') {
      return;
    }
    const key = typeof event.id !== 'undefined' ? event.id : `${event.timestamp}-${matched.length}`;
    if (seen.has(key)) {
      return;
    }

    const idMatches = gatherCandidateIds(event).some((value) => userIds.has(value));
    let textMatches = false;
    if (!idMatches && tokens.size) {
      const lowerTokens = Array.from(tokens);
      textMatches = gatherTextFields(event).some((field) => {
        const value = String(field).toLowerCase();
        return lowerTokens.some((token) => token && value.includes(token));
      });
    }

    if (idMatches || textMatches) {
      seen.add(key);
      matched.push(event);
    }
  });

  return {
    events: matched,
    tokens: Array.from(tokens),
    fallback: matched.length === 0 && original.length > 0,
  };
};

const eventFilters = {
  scopeEventsForClient,
};

export default eventFilters;
